import { values } from 'lodash';

import { SchemaField } from '../../generic/serialization/schema-field';
import { SerializableObjectSchema } from '../../generic/serialization/serializable-object-schema';

import { ActorIdType } from './actor-type';

export class ActorSchema extends SerializableObjectSchema {
  public static readonly actorIdType = 'actorIdType';

  public static readonly actorId = 'actorId';

  ////////////////////////////////////////////////////////////////////////////////////////////////
  // Constants
  ////////////////////////////////////////////////////////////////////////////////////////////////

  static Defaults = class {
    public static readonly actorId = undefined;

    public static readonly actorIdType = undefined;
  };

  ////////////////////////////////////////////////////////////////////////////////////////////////
  // Schema Parameters
  ////////////////////////////////////////////////////////////////////////////////////////////////

  public getSchemaDefinition(): { [key: string]: import('joi').AnySchema } {
    const parameters = {} as any;

    /* eslint-disable */
    parameters[ActorSchema.actorIdType] = SchemaField.string(ActorSchema.Defaults.actorIdType)
      .allow(...values(ActorIdType))
      .required();
    parameters[ActorSchema.actorId] = SchemaField.string(ActorSchema.Defaults.actorId).required();
    /* eslint-enable */

    return parameters;
  }
}
